import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Activity, TrendingUp, Loader2 } from 'lucide-react'
import { useState } from 'react'

export const Simulator = () => {
  const [isRunning, setIsRunning] = useState(false)
  
  const handleRunSimulation = async () => {
    setIsRunning(true)
    try {
      // TODO: Implementare chiamata API per eseguire la simulazione
      // await simulatorService.runSimulation({ firmId, accountSize, winRate, risk, days })
      await new Promise(resolve => setTimeout(resolve, 2000)) // Simulazione temporanea
      alert('Simulazione completata con successo')
    } catch (err) {
      alert('Errore durante la simulazione: ' + (err instanceof Error ? err.message : 'Unknown error'))
    } finally {
      setIsRunning(false)
    }
  }
  
  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold flex items-center space-x-2">
          <Activity className="w-8 h-8" />
          <span>Challenge Simulator</span>
        </h1>
        <p className="text-muted-foreground">Simulate prop firm challenge lifecycle and equity curves</p>
      </div>

      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-4">
          <Card>
            <CardHeader>
              <CardTitle>Simulation Parameters</CardTitle>
              <CardDescription>Configure simulation settings</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <Label>Prop Firm</Label>
                <Select>
                  <SelectTrigger>
                    <SelectValue placeholder="Select firm" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="ftmo">FTMO</SelectItem>
                    <SelectItem value="mff">MyForexFunds</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div className="space-y-2">
                <Label>Account Size</Label>
                <Select>
                  <SelectTrigger>
                    <SelectValue placeholder="Select size" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="10k">$10,000</SelectItem>
                    <SelectItem value="50k">$50,000</SelectItem>
                    <SelectItem value="100k">$100,000</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div className="space-y-2">
                <Label>Daily Win Rate (%)</Label>
                <Input type="number" placeholder="55" defaultValue="55" />
              </div>

              <div className="space-y-2">
                <Label>Risk per Trade (%)</Label>
                <Input type="number" placeholder="1" defaultValue="1" />
              </div>

              <div className="space-y-2">
                <Label>Trading Days</Label>
                <Input type="number" placeholder="30" defaultValue="30" />
              </div>

              <Button 
                className="w-full" 
                disabled={isRunning}
                onClick={handleRunSimulation}
              >
                {isRunning ? (
                  <>
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    Simulazione in corso...
                  </>
                ) : (
                  <>
                    <TrendingUp className="w-4 h-4 mr-2" />
                    Avvia Simulazione
                  </>
                )}
              </Button>
            </CardContent>
          </Card>
        </div>

        <div className="col-span-8">
          <Card>
            <CardHeader>
              <CardTitle>Simulation Results</CardTitle>
              <CardDescription>Equity curve and challenge progress</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="h-96 flex items-center justify-center border-2 border-dashed rounded-lg">
                <div className="text-center text-muted-foreground">
                  <Activity className="w-12 h-12 mx-auto mb-2 opacity-50" />
                  <p>Run a simulation to see equity curves and statistics</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
}
